import { memo } from "react";
import Box from "@mui/material/Box";
import ActiveStatus from "./ActiveStatus";
import PlatformStatus from "./PlatformStatus";
import PaymentMethods from "./PaymentMethods";

const ECommerceSettings = () => (
    <Box
        sx={{
            display: 'grid',
            gap: 2
        }}
    >
        <ActiveStatus />
        <PlatformStatus />
        <PaymentMethods />
    </Box>
);

export default memo(ECommerceSettings);
